/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AccountProviderTypeEnum = 'AWS' | 'GCP';

export const AccountProviderTypeEnum = {

    AWS: 'AWS' as AccountProviderTypeEnum,

    GCP: 'GCP' as AccountProviderTypeEnum
};

